export var DateInputInteractionMode;
(function (DateInputInteractionMode) {
    DateInputInteractionMode["None"] = "none";
    DateInputInteractionMode["Caret"] = "caret";
    DateInputInteractionMode["Selection"] = "selection";
})(DateInputInteractionMode || (DateInputInteractionMode = {}));
